import { BaseEntity } from 'yt-ng-framework';

export class Veroispovest extends BaseEntity {
    constructor(){
        super();
    }
    
    Naziv: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        return this;
    }

    Serialize(input: Veroispovest){
        return input;
    }
}
